/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import CustomThemeButton, {
	type CustomThemeButtonProps,
} from '@atlaskit/button/custom-theme-button';
import { useEntryPointButtonTrigger } from '@jira/platform__entry-point-button-trigger/src/index.tsx';
import { ModalEntryPointContainer } from '@jira/platform__entry-point-modal-container/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian+jira-entry-point
import { useEntryPoint } from '@jira/platform__entry-point/src/controllers/use-entry-point/index.tsx';
import { entryPointPremiumUpgradeModal } from '../../entryPointPremiumUpgradeModal.entrypoint.tsx';

export type PremiumUpgradeModalEntryPointButtonProps = Exclude<CustomThemeButtonProps, 'ref'>;

const entryPointParams = {};
export const PremiumUpgradeModalEntryPointButton = (
	buttonProps: PremiumUpgradeModalEntryPointButtonProps,
): React.JSX.Element => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		entryPointPremiumUpgradeModal,
		entryPointParams,
	);
	const buttonTrigger = useEntryPointButtonTrigger(entryPointActions);
	return (
		<>
			<CustomThemeButton {...buttonProps} ref={buttonTrigger} />
			<ModalEntryPointContainer
				entryPointReferenceSubject={entryPointReferenceSubject}
				id="jira-premium-upgrade-modal"
				packageName="jiraPremiumUpgradeModal"
				errorFallback="flag"
				runtimeProps={{ onClose: entryPointActions.unload }}
				entryPointActions={entryPointActions}
			/>
		</>
	);
};
